/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_Full_Permissions_Enabled_MessageInputs */

const en_team_share_full_permissions_enabled_message = /** @type {(inputs: Team_Share_Full_Permissions_Enabled_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full permissions enabled. Users will have access to edit and create Event Groups.`)
};

const fr_team_share_full_permissions_enabled_message = /** @type {(inputs: Team_Share_Full_Permissions_Enabled_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autorisations complètes activées. Les utilisateurs pourront modifier et créer des groupes d’événements.`)
};

const de_team_share_full_permissions_enabled_message = /** @type {(inputs: Team_Share_Full_Permissions_Enabled_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Berechtigungen sind aktiviert. Benutzer haben Zugriff auf die Bearbeitung und Erstellung von Ereignisgruppen.`)
};

const it_team_share_full_permissions_enabled_message = /** @type {(inputs: Team_Share_Full_Permissions_Enabled_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autorizzazioni complete abilitate. Gli utenti avranno accesso per modificare e creare gruppi di eventi.`)
};

const ru_team_share_full_permissions_enabled_message = /** @type {(inputs: Team_Share_Full_Permissions_Enabled_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Полные права доступа предоставлены. Пользователи смогут редактировать и создавать группы событий.`)
};

const es_team_share_full_permissions_enabled_message = /** @type {(inputs: Team_Share_Full_Permissions_Enabled_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permisos completos habilitados. Los usuarios podrán editar y crear grupos de eventos.`)
};

const zh_cn2_team_share_full_permissions_enabled_message = /** @type {(inputs: Team_Share_Full_Permissions_Enabled_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已启用全部权限。用户可以编辑和创建活动组。`)
};

const ja_team_share_full_permissions_enabled_message = /** @type {(inputs: Team_Share_Full_Permissions_Enabled_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フル権限が有効です。ユーザーはイベントグループを編集および作成できます。`)
};

const hi_team_share_full_permissions_enabled_message = /** @type {(inputs: Team_Share_Full_Permissions_Enabled_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पूर्ण अनुमतियाँ सक्षम कर दी गई हैं। उपयोगकर्ता इवेंट ग्रुप को संपादित और निर्मित कर सकेंगे।`)
};

const pt_pt2_team_share_full_permissions_enabled_message = /** @type {(inputs: Team_Share_Full_Permissions_Enabled_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permissões totais ativadas. Os usuários terão acesso para editar e criar Grupos de Eventos.`)
};

/**
* | output |
* | --- |
* | "Full permissions enabled. Users will have access to edit and create Event Groups." |
*
* @param {Team_Share_Full_Permissions_Enabled_MessageInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_full_permissions_enabled_message = /** @type {((inputs?: Team_Share_Full_Permissions_Enabled_MessageInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Full_Permissions_Enabled_MessageInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_share_full_permissions_enabled_message(inputs)
	if (locale === "de") return de_team_share_full_permissions_enabled_message(inputs)
	if (locale === "it") return it_team_share_full_permissions_enabled_message(inputs)
	if (locale === "ru") return ru_team_share_full_permissions_enabled_message(inputs)
	if (locale === "es") return es_team_share_full_permissions_enabled_message(inputs)
	if (locale === "zh-CN") return zh_cn2_team_share_full_permissions_enabled_message(inputs)
	if (locale === "ja") return ja_team_share_full_permissions_enabled_message(inputs)
	if (locale === "hi") return hi_team_share_full_permissions_enabled_message(inputs)
	if (locale === "pt-PT") return pt_pt2_team_share_full_permissions_enabled_message(inputs)
	return en_team_share_full_permissions_enabled_message(inputs)
});